
mutation ChangeLanguageMutation($input: EditUserInput!) {
  editUser(input: $input) {
    user {
      id
      preferredLanguage
      contentLanguages
    }
  }
}